import { useEffect } from "react";
import { useReducedMotion } from "framer-motion";
import Lenis from "lenis";

export const SmoothScroll = () => {
  const reduce = useReducedMotion();
  useEffect(() => {
    if (reduce) return undefined;
    if (window.matchMedia("(pointer: coarse)").matches) return undefined;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true, wheelMultiplier: 0.95 });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, [reduce]);
  return null;
};

export const scrollToTop = (immediate = true) => {
  if (window.__lenis) window.__lenis.scrollTo(0, { immediate });
  window.scrollTo({ top: 0, left: 0, behavior: "instant" });
};

export const scrollToEl = (el, offset = -96) => {
  if (!el) return;
  const top = el.getBoundingClientRect().top + window.scrollY + offset;
  if (window.__lenis) {
    window.__lenis.scrollTo(top, { duration: 1.2, force: true });
    // safety: if Lenis did not move (e.g. not yet running), fall back to native scroll
    setTimeout(() => {
      if (Math.abs(window.scrollY - top) > 40 && window.scrollY < 10) {
        window.scrollTo({ top, behavior: "auto" });
        if (window.__lenis) window.__lenis.scrollTo(top, { immediate: true, force: true });
      }
    }, 900);
  } else {
    window.scrollTo({ top, behavior: "smooth" });
  }
};
